import React, { useEffect, useRef } from "react";
import { ConnectionState } from "./ConnectionState";

type Props = {
  state: ConnectionState;
  connections: number;
};

const ConnectionCounter = ({ state, connections }: Props) => {
  const prevConnections = useRef<number>(connections);
  const numberRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (connections !== prevConnections.current) {
      prevConnections.current = connections;

      if (numberRef.current) {
        numberRef.current.classList.remove("number-pop");
        void numberRef.current.offsetWidth; // hack to force browser to re-register element in order to retrigger animation class
        numberRef.current.classList.add("number-pop");
      }
    }
  }, [connections]);

  const renderStatusMessage = () => {
    switch (state) {
      case "connecting":
        return "Connecting...";
      case "connected":
        return (
          <>
            {connections < 2 ? (
              "Connected"
            ) : (
              <>
                <span ref={numberRef} className="number-pop">
                  {connections}
                </span>{" "}
                connections
              </>
            )}
          </>
        );
      case "failed":
        return "Connection Failed";
      default:
        return null;
    }
  };

  return (
    <div className="connectionCounter">
      <span className="text">{renderStatusMessage()}</span>
    </div>
  );
};

export default ConnectionCounter;
